/**
 * The state of a single timesheet. Named (rather than inlined) per the
 * no-magic-strings rule — add new states to this union first, then use the name.
 */
export type SheetState = 'draft' | 'submitted' | 'approved' | 'returned' | 'missing';

interface StatusPillProps {
  status: SheetState;
}

// Labels name the *sheet's state* and follow the approver prototype's vocabulary.
// Deliberately distinct from the Filter-tab / Summary-card wording ("Pending",
// "Missing"), which names a *category* of sheets rather than one sheet's state.
// Class names are unchanged — this is a label-only change.
const CONFIG: Record<SheetState, { label: string; className: string }> = {
  submitted: { label: 'Submitted', className: 'inbox-pill inbox-pill--pending' },
  approved: { label: 'Approved', className: 'inbox-pill inbox-pill--approved' },
  returned: { label: 'Returned for fix', className: 'inbox-pill inbox-pill--returned' },
  missing: { label: 'Not submitted', className: 'inbox-pill inbox-pill--missing' },
  draft: { label: 'Draft', className: 'inbox-pill inbox-pill--draft' },
};

export function StatusPill({ status }: StatusPillProps) {
  const { label, className } = CONFIG[status];
  return <span className={className}>{label}</span>;
}
